import axios from 'axios'
import library from '../../../utils/Library'

export const AddParameterApplicationInstance = async (body) => {
    const TOKEN = sessionStorage.getItem('token')
    const URL =
        library.getBaseAPIUrl('e_authz') +
        '/AddParameterApplicationInstanceEAuthz'
    return await axios({
        url: URL,
        method: 'POST',
        data: body,
        headers: { Authorization: `Bearer ${TOKEN}` }
    })
}

